











import { Vue, Component, Prop } from 'vue-property-decorator';

import NotificationMessage from './NotificationMessage.vue';

import { Notification } from './types';

@Component({
    components: {
        NotificationMessage,
    } 
})
export default class NotificationList extends Vue {
    @Prop({ default: () =>  [] }) notifications!: Notification[];

    remove(notification: Notification) {
        this.$emit('remove', notification);
    }
}
